
export interface ParseDateOptions {
  dateString: string | Date
  includeHour?: boolean
  includeSeconds?: boolean
  includeTimezone?: boolean
  locale?: 'es-ES' | 'ca-CA' | 'en-EU' | 'es-ES'| 'es-CN' | 'es-CT' | 'es-MD' | 'en-GB' | 'fr-FR' | 'de-DE' | 'pt-PT' 
  options?: Intl.DateTimeFormatOptions
}


const isValidDate = (dateString) => !isNaN(Date.parse(dateString))

export function parseDateString({ dateString, locale = 'es-ES', includeHour = false, includeSeconds = false, includeTimezone = false, options = { year: 'numeric', month: 'short', day: 'numeric',} }: ParseDateOptions): string {
  if(!isValidDate(dateString)) {
    console.warn('🗓️ dateString passed is not a valid date pattern and cannot be parsed')
    return ''
  }

  const date = new Date(dateString)

  if (includeHour) {
    options.hour = '2-digit'
    options.minute = '2-digit'
    if(includeSeconds) options.second = '2-digit'
  }

  if (includeTimezone) options.timeZoneName = 'short'

  return date.toLocaleString(locale, options)
}

export function calculateDaysUntilExpiration(now,createdDate) {
  // Calculate the time difference in milliseconds
  const timeDifference = Math.abs(Date.parse(now) - Date.parse(createdDate))

  // Convert milliseconds to days
  const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24))

  return daysDifference
}

export function getDayOfWeekName(lang: string, dayOfWeek: 0 | 1 | 2 | 3 | 4 | 5 | 6): string {
  if (typeof dayOfWeek !== 'number' || dayOfWeek < 0 || dayOfWeek > 6) {
    throw new Error(`Invalid dayOfWeek: ${dayOfWeek}`)
  }

  const options: Intl.DateTimeFormatOptions = { weekday: 'long' }
  const formatter = new Intl.DateTimeFormat(lang, options)

  const referenceSunday = new Date(Date.UTC(2023, 0, 1)) // Jan 1, 2023 = Sunday
  const targetDate = new Date(referenceSunday)
  targetDate.setUTCDate(referenceSunday.getUTCDate() + dayOfWeek)

  return formatter.format(targetDate)
}

// export function getDayOfWeekName(lang: string, dayOfWeek: 0 | 1 | 2 | 3 | 4 | 5 | 6):string {
//   const options = { weekday: 'long', locale: lang } as Intl.DateTimeFormatOptions
//   const formatter = new Intl.DateTimeFormat(lang, options)

//   // Get the name of the week day based on the day of the week integer
//   const dayName = formatter.format(new Date(Date.UTC(new Date().getFullYear(), 0, dayOfWeek )))
//   return dayName
// }

export function getDateFormatted(locale: string, dateString: string | Date): string {
  const date = new Date(dateString)

  const options: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    day: 'numeric',
    month: 'numeric'
  }

  const formatter = new Intl.DateTimeFormat(locale, options)
  const parts = formatter.formatToParts(date)
  const formattedDate = `${parts[0].value} ${parts[2].value}/${parts[4].value}`

  return formattedDate
}

export function groupByDate(data = []) {
  if (!data.length) return []

  const cartLines = [...data]
  // Sort the cartLines array by deliveryDate in ascending order
  cartLines.sort((a, b) => {
    const dateA = new Date(a.variant.deliveryDate)
    const dateB = new Date(b.variant.deliveryDate)
    return dateA.getTime() - dateB.getTime()
  })

  // Create a Map to store cartLines grouped by date
  const groupedByDate = new Map()

  // Iterate over the sorted array of cartLines
  cartLines.forEach(item => {
    const deliveryDate = new Date(item.variant.deliveryDate)

    // Create a key based on year, month, and day (ignoring hours and minutes)
    const key = new Date(
      deliveryDate.getFullYear(),
      deliveryDate.getMonth(),
      deliveryDate.getDate()
    ).toString()

    // Add the object to the corresponding group in the Map
    if (groupedByDate.has(key)) {
      groupedByDate.get(key)!.push(item)
    } else {
      groupedByDate.set(key, [item])
    }
  })

  // Convert the Map values to an array of arrays
  const result = Array.from(groupedByDate.values())
  return result
}

